<template>
  <div
    :class="[
      'c-button button--filled',
      data.rtl ? 'c-button--rtl' : false,
      textHideM ? 'c-button--mobile-hide' : '',
    ]">
    <div class="button__circle">
      <svg class="button__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.2 14.6" v-if="symbol === ''">
        <path class="icon__line" d="M25.1 7.2H4.7" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="square"/>
        <path class="icon__arrow" d="M19.6.8l7 6.4-7 6.6" fill="none" stroke="#fff" stroke-width="1.5"/>
      </svg>
      <svg class="button__icon button__icon--all" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" v-else>
        <path d="M1.5 1.5h5v5h-5z" fill="none" stroke="#fff" />
        <path d="M1.5 9.5h5v5h-5z" fill="none" stroke="#fff" />
        <path d="M10.5 1.5h5v5h-5z" fill="none" stroke="#fff" />
        <path d="M10.5 9.5h5v5h-5z" fill="none" stroke="#fff" />
      </svg>
    </div>
    <router-link
      v-if="data.routerLink"
      class="button__text"
      :to="data.url"
      :aria-label="data.content"
    >
      <span class="button__caption">{{ data.content }}</span>
    </router-link>
    <a
      v-else
      class="button__text"
      :href="data.url"
      rel="noopener"
      target="_blank"
      :aria-label="data.content"
    >
      <span class="button__caption">{{ data.content }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'baseButtonFilled',

  props: {
    data: {
      type: Object,
      required: true,
    },

    textHideM: {
      type: Boolean,
      required: false,
      default: false,
    },

    symbol: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.c-button.button--filled {
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;

  border: 0;
  background: transparent;
  outline: transparent;

  text-decoration: none;

  cursor: pointer;

  @include mq($until: ipadP) {
    &.c-button--mobile-hide {
      & .button__text {
        padding: 20px;
      }

      &.c-button--rtl .button__text {
        padding: 20px;
      }

      .button__caption {
        display: none;
      }
    }
  }

  .button__circle {
    position: absolute;
    top: 50%;
    width: 40px;
    height: 40px;
    margin-top: -20px;

    border-radius: 1.625rem;
    border: 1px solid $color-text;

    transition: width 0.4s $global-ease;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    right: 0;

    .button__icon {
      display: inline-block;
      height: 15px;

      position: relative;
      left: -13px;

      transition: all 0.4s $global-ease;

      .icon__line {
        opacity: 0;
        transform: scaleX(0);
        transform-origin: 100% 50%;
        transition: all 0.4s $global-ease;
      }
    }

    @at-root [data-theme="pink"] & {
      background-color: $color-pink;
    }

    @at-root [data-theme="blue"] & {
      background-color: $color-blue;
    }

    @at-root [data-theme="red"] & {
      background-color: $color-red;
    }

    @at-root [data-theme="azure"] & {
      background-color: $color-azure;
    }

    @at-root [data-theme="yellow"] & {
      background-color: $color-yellow;
    }

    @at-root [data-theme="ocher"] & {
      background-color: $color-ocher;
    }
  }

  .button__text {
    display: inline-block;

    position: relative;

    padding: 15px 60px 15px 25px;

    @include mq($until: mobileL) {
      padding: 15px 60px 15px 20px;
    }

    color: $color-text;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 2px;

    transition: color 0.4s $global-ease;
  }

  @at-root .pointerevents:not(.touchevents) &:hover {
    .button__circle {
      width: 100%;
    }

    .button__icon {
      margin: 0 20px 0 auto;
      left: 0;

      .icon__line {
        opacity: 1;
        transform: scaleX(1);
      }
    }

    .button__text {
      color: $color-light;
    }
  }

  &.c-button--rtl {
    .button__circle {
      left: 0;
      justify-content: flex-start;

      .button__icon {
        transform: scaleX(-1);
        left: 12px;

        &--all {
          left: 11px;
        }
      }
    }
    .button__text {
      padding: 15px 25px 15px 60px;

      @include mq($until: mobileL) {
        padding: 15px 20px 15px 60px;
      }
    }

    @at-root .pointerevents:not(.touchevents) &:hover {
      .button__circle {
        .button__icon {
          margin: 0 auto 0 20px;
          left: 0;
        }
      }
    }
  }
}
</style>
